// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-panel {
  width: var(--side-panel-width);
  background: var(--bg-secondary);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
}

.side-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 16px;
  min-height: 38px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.side-panel-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.side-panel-divider {
  height: 1px;
  background: var(--border);
  margin: 4px 0;
  flex-shrink: 0;
}

.side-panel-empty {
  color: var(--text-muted);
  font-size: 12px;
  padding: 16px;
}

.sp-nav {
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  overflow-y: auto;
  flex: 1;
}

.sp-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: left;
  padding: 7px 16px;
  font-size: 13px;
  color: var(--text-primary);
  border-left: 2px solid transparent;
  transition: background 0.1s;
}
.sp-nav-item:hover { background: var(--bg-hover); }
.sp-nav-item.active {
  background: var(--bg-active);
  border-left-color: var(--accent-light);
}

.sp-nav-indent { padding-left: 28px; }

.sp-project-item {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 8px 16px;
}
.sp-project-name { font-size: 13px; display: flex; align-items: center; gap: 5px; }
/* Project notices (red / yellow) — hover lists them */
.sp-notice {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  cursor: help;
}
.sp-notice-yellow { background: #dcaa00; color: #1e1e1e; }
.sp-notice-red    { background: var(--red); color: #fff; }
.sp-notice-blue   { background: #3794ff; color: #fff; }
.sp-project-hull { font-size: 11px; color: var(--text-muted); }

/* Choosing which projects to show (foreman and above) */
.sp-header-actions { display: flex; align-items: center; gap: 2px; }
.btn-icon.sp-filter-on { color: var(--accent-light); }
.sp-choose-hint { padding: 8px 16px 2px; font-size: 12px; color: var(--text-muted); }
.sp-choose-actions { display: flex; gap: 12px; padding: 0 16px 6px; }
.sp-choose-link {
  background: none;
  border: none;
  padding: 2px 0;
  font-size: 12px;
  color: var(--accent-light);
  cursor: pointer;
}
.sp-choose-link:hover { text-decoration: underline; }
.sp-choose-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  cursor: pointer;
  color: var(--text-primary);
}
.sp-choose-row:hover { background: var(--bg-hover); }
.sp-choose-row .sp-project-name { flex: 1; min-width: 0; }
.sp-hidden-note {
  display: block;
  width: 100%;
  background: none;
  border: none;
  border-top: 1px solid var(--border);
  margin-top: 4px;
  padding: 8px 16px;
  text-align: left;
  font-size: 12px;
  color: var(--text-muted);
  cursor: pointer;
}
.sp-hidden-note:hover { color: var(--text-primary); }

.sp-group-header {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  padding: 8px 12px 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
  border-top: 1px solid var(--border);
  margin-top: 4px;
}
.sp-group-header:hover { color: var(--text-primary); }
.sp-group-chevron {
  flex-shrink: 0;
  transition: transform 0.15s;
}
.sp-group-chevron.open { transform: rotate(90deg); }

.sp-project-row {
  display: flex;
  align-items: stretch;
}
.sp-project-row .sp-nav-item { flex: 1; }

/* Planning diagram rows */
.sp-diagram-rename {
  flex: 1;
  background: var(--bg-input);
  border: 1px solid var(--accent-light);
  border-radius: 2px;
  color: var(--text-primary);
  font-size: 13px;
  padding: 3px 6px;
  outline: none;
  min-width: 0;
  margin: 4px 0 4px 16px;
}
.sp-diagram-btn { opacity: 0; width: 22px; height: 22px; }
.sp-project-row:hover .sp-diagram-btn { opacity: 1; }
.sp-diagram-new-row { display: flex; align-items: center; gap: 4px; padding: 4px 8px; }

.sp-project-info-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  flex-shrink: 0;
  color: var(--text-muted);
  border-left: 1px solid var(--border);
  border-radius: 0;
  transition: color 0.1s, background 0.1s;
}
.sp-project-info-btn:hover { color: var(--text-primary); background: var(--bg-hover); }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .side-panel { width: 100%; flex: 1; min-height: 0; }
  .sp-nav-item { padding: 14px 20px; font-size: 15px; }
  .sp-project-info-btn { display: flex; }
}

/* Small uppercase heading between groups of nav items (e.g. Planning → Gantt diagrams) */
.sp-subheader {
  padding: 10px 12px 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

/* Quote rows: name + quote number */
.sp-quote-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sp-quote-no { font-size: 11px; color: var(--text-muted); flex-shrink: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/layout/SidePanel.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;AAC7B;AACA,qBAAqB,2BAA2B,EAAE;AAClD;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,iBAAiB,kBAAkB,EAAE;;AAErC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;AACnB;AACA,mBAAmB,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClF,sDAAsD;AACtD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,sBAAsB,EAAE,WAAW,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,WAAW,EAAE;AACtD,mBAAmB,eAAe,EAAE,wBAAwB,EAAE;;AAE9D,wDAAwD;AACxD,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnE,yBAAyB,0BAA0B,EAAE;AACrD,kBAAkB,qBAAqB,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACpF,qBAAqB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACpE;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;AACA,wBAAwB,0BAA0B,EAAE;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;AACA,uBAAuB,2BAA2B,EAAE;AACpD,kCAAkC,OAAO,EAAE,YAAY,EAAE;AACzD;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA,wBAAwB,0BAA0B,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;AACA,yBAAyB,0BAA0B,EAAE;AACrD;EACE,cAAc;EACd,2BAA2B;AAC7B;AACA,yBAAyB,wBAAwB,EAAE;;AAEnD;EACE,aAAa;EACb,oBAAoB;AACtB;AACA,+BAA+B,OAAO,EAAE;;AAExC,0BAA0B;AAC1B;EACE,OAAO;EACP,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA,kBAAkB,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE;AACzD,wCAAwC,UAAU,EAAE;AACpD,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAEtF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,uCAAuC;AACzC;AACA,6BAA6B,0BAA0B,EAAE,2BAA2B,EAAE;;AAEtF;EACE,cAAc,WAAW,EAAE,OAAO,EAAE,aAAa,EAAE;EACnD,eAAe,kBAAkB,EAAE,eAAe,EAAE;EACpD,uBAAuB,aAAa,EAAE;AACxC;;AAEA,yFAAyF;AACzF;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC,iBAAiB,OAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACxG,eAAe,eAAe,EAAE,wBAAwB,EAAE,cAAc,EAAE","sourcesContent":[".side-panel {\n  width: var(--side-panel-width);\n  background: var(--bg-secondary);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.side-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 12px 0 16px;\n  min-height: 38px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.side-panel-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n}\n\n.side-panel-divider {\n  height: 1px;\n  background: var(--border);\n  margin: 4px 0;\n  flex-shrink: 0;\n}\n\n.side-panel-empty {\n  color: var(--text-muted);\n  font-size: 12px;\n  padding: 16px;\n}\n\n.sp-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 6px 0;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.sp-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  text-align: left;\n  padding: 7px 16px;\n  font-size: 13px;\n  color: var(--text-primary);\n  border-left: 2px solid transparent;\n  transition: background 0.1s;\n}\n.sp-nav-item:hover { background: var(--bg-hover); }\n.sp-nav-item.active {\n  background: var(--bg-active);\n  border-left-color: var(--accent-light);\n}\n\n.sp-nav-indent { padding-left: 28px; }\n\n.sp-project-item {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 8px 16px;\n}\n.sp-project-name { font-size: 13px; display: flex; align-items: center; gap: 5px; }\n/* Project notices (red / yellow) — hover lists them */\n.sp-notice {\n  flex-shrink: 0;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 900;\n  line-height: 1;\n  cursor: help;\n}\n.sp-notice-yellow { background: #dcaa00; color: #1e1e1e; }\n.sp-notice-red    { background: var(--red); color: #fff; }\n.sp-notice-blue   { background: #3794ff; color: #fff; }\n.sp-project-hull { font-size: 11px; color: var(--text-muted); }\n\n/* Choosing which projects to show (foreman and above) */\n.sp-header-actions { display: flex; align-items: center; gap: 2px; }\n.btn-icon.sp-filter-on { color: var(--accent-light); }\n.sp-choose-hint { padding: 8px 16px 2px; font-size: 12px; color: var(--text-muted); }\n.sp-choose-actions { display: flex; gap: 12px; padding: 0 16px 6px; }\n.sp-choose-link {\n  background: none;\n  border: none;\n  padding: 2px 0;\n  font-size: 12px;\n  color: var(--accent-light);\n  cursor: pointer;\n}\n.sp-choose-link:hover { text-decoration: underline; }\n.sp-choose-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  cursor: pointer;\n  color: var(--text-primary);\n}\n.sp-choose-row:hover { background: var(--bg-hover); }\n.sp-choose-row .sp-project-name { flex: 1; min-width: 0; }\n.sp-hidden-note {\n  display: block;\n  width: 100%;\n  background: none;\n  border: none;\n  border-top: 1px solid var(--border);\n  margin-top: 4px;\n  padding: 8px 16px;\n  text-align: left;\n  font-size: 12px;\n  color: var(--text-muted);\n  cursor: pointer;\n}\n.sp-hidden-note:hover { color: var(--text-primary); }\n\n.sp-group-header {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  padding: 8px 12px 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  text-align: left;\n  cursor: pointer;\n  border-top: 1px solid var(--border);\n  margin-top: 4px;\n}\n.sp-group-header:hover { color: var(--text-primary); }\n.sp-group-chevron {\n  flex-shrink: 0;\n  transition: transform 0.15s;\n}\n.sp-group-chevron.open { transform: rotate(90deg); }\n\n.sp-project-row {\n  display: flex;\n  align-items: stretch;\n}\n.sp-project-row .sp-nav-item { flex: 1; }\n\n/* Planning diagram rows */\n.sp-diagram-rename {\n  flex: 1;\n  background: var(--bg-input);\n  border: 1px solid var(--accent-light);\n  border-radius: 2px;\n  color: var(--text-primary);\n  font-size: 13px;\n  padding: 3px 6px;\n  outline: none;\n  min-width: 0;\n  margin: 4px 0 4px 16px;\n}\n.sp-diagram-btn { opacity: 0; width: 22px; height: 22px; }\n.sp-project-row:hover .sp-diagram-btn { opacity: 1; }\n.sp-diagram-new-row { display: flex; align-items: center; gap: 4px; padding: 4px 8px; }\n\n.sp-project-info-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  flex-shrink: 0;\n  color: var(--text-muted);\n  border-left: 1px solid var(--border);\n  border-radius: 0;\n  transition: color 0.1s, background 0.1s;\n}\n.sp-project-info-btn:hover { color: var(--text-primary); background: var(--bg-hover); }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .side-panel { width: 100%; flex: 1; min-height: 0; }\n  .sp-nav-item { padding: 14px 20px; font-size: 15px; }\n  .sp-project-info-btn { display: flex; }\n}\n\n/* Small uppercase heading between groups of nav items (e.g. Planning → Gantt diagrams) */\n.sp-subheader {\n  padding: 10px 12px 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n}\n\n/* Quote rows: name + quote number */\n.sp-quote-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.sp-quote-no { font-size: 11px; color: var(--text-muted); flex-shrink: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
